<template>
  <div class="btn-group" ref="dropdownFilter">
    <div @click="toggleMenu()" class="dropdown-toggle">
      <span class="selected-name">
        Depots <span> (selected - <span class="selectedvalue">{{checkedData.length}}</span>)</span>
      </span>
      <svgicon name="categorydropdown" v-if="options.length>1"
        class="dropdown-icon" width="11.23" height="18" :original="true" />
    </div>
    <div class="checkboxdb-menu" v-if="showMenu && options.length>1">
    <ul class="dropdown-menucontent dark-dropdown-menu">
      <li class="dropdown-menuscroll">
      <CheckboxGroup v-model="checkedData" >
          <Checkbox v-for="(option, index) in options" :key="option.id" :label="option.id" > {{ option.name }}</Checkbox>
      </CheckboxGroup>
      </li>
      <button @click="updateOption()" class="btn btn-primary">Apply</button>
    </ul>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      selectedOption: [],
      showMenu: false,
      placeholderText: 'Please select an item',
      checkedData: [],
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
  },
  mounted() {
    this.selectedOption = this.selected;
    const defaultDepot = this.options[0];
    this.checkedData = [defaultDepot.id];
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    updateOption() {
      this.$emit('updateOption', this.checkedData);
      this.showMenu = false;
    },

    toggleMenu() {
      if (this.options.length > 1) {
        this.showMenu = !this.showMenu;
      }
    },
    documentClick(event) {
      const el = this.$refs.dropdownFilter;
      const target = event.target;
      if ((el !== target) && !el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.selectedvalue{
  width: 20px;
  display: inline-block;
  text-align: center;
}
</style>
